import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import ProductIcon from '../../common/ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuiteFeatureTableHeader = ({
  productLine
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(ProductIcon, {
      name: productLine,
      iconStyle: {
        inlineSize: '24px',
        marginInlineEnd: '300'
      }
    }), /*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-300",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "suiteFeatureTable.section.title",
        options: {
          product: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `productLine.${productLine}`
          })
        }
      })
    })]
  });
};
export default SuiteFeatureTableHeader;